
import * as THREE from 'three';

export class CameraMatrix {

    /**
     * 元の行列を保持するためのコンストラクタです。
     * 引数としてTHREE.Matrix4型のmatrixを受け取り、クラスのプロパティとして保持
     */
    constructor(public matrix: THREE.Matrix4) { // 元の行列を保持
        ;
    }

    /**
     * ARKitのカメラ行列をWebCADの行列に変換する
     */
    public ARKitToWebcad(mat4: THREE.Matrix4): THREE.Matrix4 {
        const right = this.getRight(mat4);
        const up = this.getUp(mat4);
        const direction = this.getDirection(mat4);
        const matrix = new THREE.Matrix4();
        const elements = [
            right.x, right.y, right.z, mat4.elements[3],
            up.x, up.y, up.z, mat4.elements[7],
            direction.x, direction.y, direction.z, mat4.elements[11],
            mat4.elements[12], mat4.elements[13], mat4.elements[14], mat4.elements[15]
        ];
        matrix.elements = elements;
        return matrix;
    }

    /**
     * スケールを１倍にして返す
     */
    public scale1x(mat4: THREE.Matrix4) {
        const elemets = mat4.elements;
        const Xaxis = new THREE.Vector3(elemets[0], elemets[1], elemets[2]).normalize();
        const Yaxis = new THREE.Vector3(elemets[4], elemets[5], elemets[6]).normalize();
        const Zaxis = new THREE.Vector3(elemets[8], elemets[9], elemets[10]).normalize();
        const matrix = new THREE.Matrix4();
        matrix.elements = [
            Xaxis.x, Xaxis.y, Xaxis.z, elemets[3],
            Yaxis.x, Yaxis.y, Yaxis.z, elemets[7],
            Zaxis.x, Zaxis.y, Zaxis.z, elemets[11],
            elemets[12], elemets[13], elemets[14], elemets[15],
        ];
        return matrix;
    }

    /**
     * 右方向ベクトルを取得する
     */
    public getRight(mat4: THREE.Matrix4): THREE.Vector3 {
        // 行列のy軸ベクトル
        const vec3 = new THREE.Vector3(mat4.elements[4], mat4.elements[5], mat4.elements[6]);
        // mat4から、行列のy軸ベクトルを取得し、-1倍して返す
        return vec3.multiplyScalar(-1);
    }

    /**
     * 上方向ベクトルを取得する
     */
    public getUp(mat4: THREE.Matrix4): THREE.Vector3 {
        // 行列のx軸ベクトル
        const vec3 = new THREE.Vector3(mat4.elements[0], mat4.elements[1], mat4.elements[2]);
        // mat4から、行列のx軸ベクトルを取得し、-1倍して返す
        return vec3.multiplyScalar(-1);
    }

    /**
     * カメラの方向ベクトルを取得する
     */
    public getDirection(mat4: THREE.Matrix4): THREE.Vector3 {
        // 行列のz軸ベクトル
        const dir = new THREE.Vector3(mat4.elements[8], mat4.elements[9], mat4.elements[10]);
        // mat4から、行列のz軸ベクトルを取得し、-1倍して返す
        return dir.multiplyScalar(-1);
    }

    
}